import React, { useEffect, useState } from 'react'
import CaptureScreen from '../../SlidePanels/CaptureScreen'
import { useDispatch, useSelector } from 'react-redux'
import { handleShowPhotoModal } from '../../../action/index';

const PhotosModal = () => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.reducer);
    const [height, setHeight] = useState(window.innerHeight);
    useEffect(() => {
        setHeight(window.innerHeight);
    }, [window.innerHeight])
    return (
        <div className='photos-overlay' style={{ height: (window.innerWidth < 993 ? height-44 : height)+'px', transform: state.isShowPhotoModal ? "translateX(0)" : "translateX(100%)", opacity: state.isShowPhotoModal ? 1 : 0 }}>
            <div className='close-action-container'>
                <div className='close-action' onClick={() => dispatch(handleShowPhotoModal())}>
                    <i className='icon-close'></i>
                </div>
            </div>
            <CaptureScreen />
        </div>
    )
}

export default PhotosModal